import FranchiseSelect from './FranchiseSelect';

export default FranchiseSelect;
